import HTTP from '@/common/HTTP'

import {actionTypes, mutationTypes} from './DatenpoolTagsTypes';

// initial state
const initialState = () => ({
  loading: false, items: [],
})

// getters
const getters = {}

// mutations
const mutations = {
  [mutationTypes.SET_LOADING](state, item) {
    state.loading = item
  },

  [mutationTypes.SET_TAGS](state, item) {
    state.items = item
  },
}

// actions
const actions = {
  async [actionTypes.FETCH_TAGS]({commit, dispatch}) {
    commit(mutationTypes.SET_LOADING, true)

    try {
      const result = await HTTP.get('/datenpool/tags?&size=128&sort=tag')
      console.log(result)

      commit(mutationTypes.SET_TAGS, result.data.content)
    } catch (e) {
      console.log(e)

      this._vm.$notify({
        group: 'app',
        title: 'Fehler',
        type: 'error',
        text: 'Schlagwörter konnten nicht aktualisiert werden.',
        duration: 3000
      })

      commit(mutationTypes.SET_TAGS, [])
    }

    commit(mutationTypes.SET_LOADING, false)
  },

  async [actionTypes.CREATE_TAG]({commit, dispatch}, newTag) {
    commit(mutationTypes.SET_LOADING, true)

    try {
      // axios overwrites default content-type for string to text/plain, we need json
      const config = {headers: {'Content-Type': 'application/json'}};
      await HTTP.post(`/datenpool/tags/create`, newTag, config)

      this._vm.$notify({
        group: 'app',
        title: 'Erfolgreich',
        type: 'success',
        text: 'Schlagwort erfolgreich erstellt.',
        duration: 3000
      })
    } catch (e) {
      console.error(e)

      this._vm.$notify({
        group: 'app',
        title: 'Fehler',
        type: 'error',
        text: 'Schlagwort konnte nicht erstellt werden.',
        duration: 3000
      })
    }

    await dispatch(actionTypes.FETCH_TAGS)
  },

  async [actionTypes.DELETE_TAG]({commit, dispatch}, tagId) {
    commit(mutationTypes.SET_LOADING, true)

    try {
      await HTTP.delete(`/datenpool/tags/${tagId}/delete`)

      this._vm.$notify({
        group: 'app',
        title: 'Erfolgreich',
        type: 'success',
        text: 'Schlagwort wurde erfolgreich gelöscht.',
        duration: 3000
      })
    } catch (e) {
      console.error(e)

      this._vm.$notify({
        group: 'app',
        title: 'Fehler',
        type: 'error',
        text: 'Schlagwort konnte nicht gelöscht werden. Zuvor darf keine Datei mehr mit diesem Schlagwort versehen sein.',
        duration: 3000
      })
    }

    await dispatch(actionTypes.FETCH_TAGS)
  }
}

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/DatenpoolTags.js